import { useCallback, useEffect, useState } from 'react';
import { useBrowserPushEventId } from '../../_lib/ViewFetcher';
import { SocketEventAction } from '../../types/api/SocketEventAction';
import { SonApiResponse } from '../../types/api/SonApiResponse';
import { useWebSockets } from '../../_lib/WebSocketManager';

// Errors received from WS
type ThreadErrorResponse = SonApiResponse & {
  postId: string;
};

/**
 * Error Messages received for Thread Posts via Websockets.
 *
 * - location where Attached Files for Posts are uploaded is different from where they will be shown.
 * - collect errors for all postIds here, so only use this hook on top level of the block!
 */
export function useWebsocketSyncedErrors() {
  const browserPushEventId = useBrowserPushEventId();
  const [errors, setErrors] = useState<ThreadErrorResponse[]>([]);
  const subscribe = useWebSockets();

  const resetErrors = () => setErrors([]);

  const onError = useCallback((item: ThreadErrorResponse) => setErrors(prev => [item, ...prev]), []);
  useEffect(() => subscribe(`${browserPushEventId}:${SocketEventAction.ERROR}`, onError));

  const getErrorsByPostId = (postId: string): ThreadErrorResponse[] => {
    return errors.filter(error => error.postId === postId);
  };

  return { getErrorsByPostId, resetErrors, errors };
}
